import DataBinder from "../DataBinder.js"
import SwapPage from "../SwapPage.js"
export default class StatsController {

  constructor() {

  }
  show(path, model) {
    
    const userdata = app.userdata;
    const stats = userdata.stats || {};


    //get page
    let pageId = path.split("/")[0];

    const dataBinder = new DataBinder();
    dataBinder.populate(pageId, stats);

    const swapPage = new SwapPage();
    swapPage.swapPage(pageId);
  }
}